import axiosInstance from "./axiosInstance";
import Configs from "../utils/Configs";

const FcmAPI = {
  updateFcmToken: async (fcmToken) => {
    try {
      const response = await axiosInstance.post(Configs.updateFcmTokenEp, {
        fcm_token: fcmToken,
      });

      if (response.status === 200 && response.data.status === "success") {
        console.log("🔥 FCM token synced with backend");
        return true;
      } else {
        console.error("❌ Failed to update FCM token:", response.data);
        return false;
      }
    } catch (error) {
      console.error("❌ Error updating FCM token:", error);
      return false;
    }
  },
};

export default FcmAPI;
